import { Component, Input, OnChanges} from '@angular/core';

import { ConvertDatePipe } from '../../../shared/filters/convert-date/convert-date.pipe';
import { AfOrderByPipe } from '@shared/filters/af-order-by/af-order-by.pipe';
import { NgClass } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { AfTranslateDirective } from '../../../shared/modules/translate/directive/af-translate.directive';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';

@Component({
    selector: 'process-record',
    templateUrl: './process-record.component.html',
    imports: [
      AfTranslateDirective,
      TooltipModule,
      NgClass,
      AfOrderByPipe,
      ConvertDatePipe,
      AfTranslatePipe]
})
export class ProcessRecordComponent implements OnChanges {
  processRecord: any = {
    id: this.commonUtilsService.createId(),
    transitionsList: [],
    fullScreen: false
  }
  constructor(
    private apiService: ApiServiceService,
    private commonUtilsService: CommonUtilsService) {}

  @Input() conceptObjectId: any = null;

  ngOnChanges(): void {
    this.getHistoryProcess();
  }

  getHistoryProcess() {
    this.apiService.getWithTranslate('processesdata', this.conceptObjectId + '/history')
      .then((data:any)=> {
        this.processRecord.transitionsList = data;
      }, (errorData:any)=>{});
  }
}
